import styled from 'styled-components';

export const MainContainer = styled.div<{ $sceneIsDragging?: boolean }>`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;

  overflow: hidden;

  ${({ $sceneIsDragging }) =>
    $sceneIsDragging &&
    `
      cursor: move;
    `}
`;

export const TopBarContainer = styled.div`
  z-index: 1;
  width: 100%;
  height: 45px;

  background-color: var(--panel-bg-color);
`;

export const ContentContainer = styled.div`
  position: relative;
  margin: 5px 0;

  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ToolbarContainer = styled.div<{ $collapsed?: boolean }>`
  width: 350px;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;

  overflow: hidden;
  display: flex;

  border-radius: 0 10px 10px 0;
  /* background-color: var(--panel-bg-color-secondary); */

  transition:
    width 1s cubic-bezier(0.075, 0.82, 0.165, 1),
    opacity 0.3s ease;
  ${({ $collapsed }) =>
    $collapsed &&
    `
      width: 45px;
    `}
`;

export const SidebarContainer = styled.div<{ $hidden?: boolean }>`
  width: 350px;
  height: 100%;
  position: absolute;
  left: auto;
  right: 0;

  overflow: hidden;
  display: flex;

  border-radius: 10px 0 0 10px;
  background-color: var(--panel-bg-color-secondary);

  transition:
    width 1s cubic-bezier(0.075, 0.82, 0.165, 1),
    opacity 0.3s ease;

  ${({ $hidden }) =>
    $hidden &&
    `
      pointer-events: none;
      opacity: 0;
    `}
`;

export const StateBarContainer = styled.div`
  position: absolute;
  bottom: 0;

  & > div {
    transition: opacity 0.3s ease;
  }
`;

export const FooterContainer = styled.div`
  z-index: 1;
  box-sizing: border-box;
  width: 100%;
  padding: 5px;

  display: flex;
  justify-content: space-between;

  background-color: var(--panel-bg-color);
  color: var(--text-color-secondary);
  font-size: 12px !important;
`;
